// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8owOe","toggle":"styles_toggle__34M0G","preview":"styles_preview__1s8jn"};